export function getFileNameFromUrl(url: string) {
  try {
    const pathname = new URL(url).pathname;
    return pathname.split('/').pop() || '';
  } catch {
    return '';
  }
}
